/* HeyBear · Cart drawer: side cart on the Shopify AJAX cart, free-shipping car bar, Big Bear swap + 102g single-bag upsells. */
HB.section('cart-drawer', function (root) {
  var $ = function (s) { return root.querySelector(s); };
  var drawer = $('#drawer'), scrim = $('#scrim'), cfg = HB.config(), t = cfg.t || {}, off = [], lastFocus = null;
  /* Older saved section-group data can omit settings added later. Only an
     explicit merchant choice of false disables this collection-led upsell. */
  var upsellEnabled = cfg.upsellOn !== false;
  var upsellLoading = upsellEnabled, alive = true, productRequests = {};
  var MAX_SINGLE_BAG_UPSELLS = 4, reconcilingUpsells = false;
  var on = function (el, ev, fn, o) { el.addEventListener(ev, fn, o); off.push(function () { el.removeEventListener(ev, fn, o); }); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  function productJsonUrl(product) {
    var url = product && (product.url || product.handle && ('/products/' + product.handle));
    if (!url) return '';
    try {
      var parsed = new URL(url, location.href);
      parsed.pathname = parsed.pathname.replace(/\/$/, '') + '.js';
      parsed.search = ''; parsed.hash = '';
      return parsed.href;
    } catch (_) { return ''; }
  }
  function fetchProduct(product) {
    var url = productJsonUrl(product);
    if (!url) return Promise.resolve(null);
    if (!productRequests[url]) {
      productRequests[url] = fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (response) {
        if (!response.ok) return null;
        return response.json();
      }).catch(function () { return null; });
    }
    return productRequests[url];
  }
  function singleBagKey(product) {
    var lookup = String((product && product.handle) || '') + ' ' + String((product && product.title) || '');
    lookup = lookup.toLowerCase();
    if (lookup.indexOf('watermelon') > -1) return 'watermelon';
    if (lookup.indexOf('strawberry') > -1) return 'strawberry';
    if (lookup.indexOf('grape') > -1) return 'grape';
    if (lookup.indexOf('apple') > -1) return 'apple';
    if (lookup.indexOf('cola') > -1) return 'cola';
    return String((product && product.handle) || 'single-bag').replace(/[^a-z0-9-]/gi, '-').toLowerCase();
  }
  function singleBagColours(key) {
    return {
      cola: ['#D9B793', '#8A5A33'],
      apple: ['#C9E4A6', '#6A8A34'],
      grape: ['#CBBBEA', '#7A5BC0'],
      strawberry: ['#F2BDB8', '#D0605A'],
      watermelon: ['#F59A9E', '#E0525C']
    }[key] || ['#F6C1C8', '#D8443B'];
  }
  function collectionPrice(value) {
    if (value == null || value === '') return null;
    if (typeof value === 'string' && value.indexOf('.') > -1) {
      var dollars = Number(value);
      return Number.isFinite(dollars) ? Math.round(dollars * 100) : null;
    }
    var cents = Number(value);
    return Number.isFinite(cents) ? Math.round(cents) : null;
  }
  function collectionSingleBag(product) {
    var variants = product && product.variants || [];
    var variant = variants.filter(function (item) {
      return item && item.available === true && item.id && item.price != null;
    })[0];
    if (!variant) return null;
    var key = singleBagKey(product), colours = singleBagColours(key);
    var price = collectionPrice(variant.price), compare = collectionPrice(variant.compare_at_price);
    if (price == null) return null;
    var featured = variant.featured_image && (variant.featured_image.src || variant.featured_image.url);
    var productImage = product.featured_image && (product.featured_image.src || product.featured_image.url || product.featured_image);
    var firstImage = product.images && product.images[0];
    if (firstImage && typeof firstImage === 'object') firstImage = firstImage.src || firstImage.url;
    return {
      key: key,
      handle: product.handle,
      url: product.url || ((HB.routes.root || '/').replace(/\/?$/, '/') + 'products/' + product.handle),
      name: product.title,
      pc: colours[0],
      bc: colours[1],
      pack: featured || productImage || firstImage || null,
      variant: {
        id: variant.id,
        title: variant.title,
        sku: variant.sku,
        price: price,
        compare: compare,
        available: true
      }
    };
  }
  function fetchSingleBagCollection() {
    var rootUrl = (HB.routes.root || '/').replace(/\/?$/, '/');
    var url = rootUrl + 'collections/heybear-102g-cart-singles/products.json?limit=250';
    return fetch(url, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) return null;
      return response.json();
    }).then(function (payload) {
      if (!payload || !Array.isArray(payload.products)) return null;
      return payload.products.map(collectionSingleBag).filter(Boolean);
    }).catch(function () { return null; });
  }
  var singleBagCandidates = [
    { key: 'cola', sku: 'COL-1', title: 'Cola 102g', handles: ['cola-102g', 'sour-cola-102g', 'single-cola-102g'] },
    { key: 'apple', sku: 'SAP-1', title: 'Sour Apple 102g', handles: ['sour-apple-102g', 'apple-102g', 'single-sour-apple-102g'] },
    { key: 'grape', sku: 'GRP-1', title: 'Grape 102g', handles: ['grape-102g', 'sour-grape-102g', 'single-sour-grape-102g'] },
    { key: 'strawberry', sku: 'STB-1', title: 'Strawberry 102g', handles: ['strawberry-102g', 'single-strawberry-102g'] },
    { key: 'watermelon', sku: 'WAT-1', title: 'Watermelon 102g', handles: ['watermelon-102g', 'sour-watermelon-102g', 'single-sour-watermelon-102g'] }
  ];
  function firstLiveHandle(handles, index) {
    if (index >= handles.length) return Promise.resolve(null);
    return fetchProduct({ handle: handles[index] }).then(function (product) {
      var bag = collectionSingleBag(product);
      return bag || firstLiveHandle(handles, index + 1);
    });
  }
  function firstLiveSearchProduct(products, index) {
    if (index >= products.length) return Promise.resolve(null);
    var result = products[index] || {};
    return fetchProduct({ handle: result.handle, url: result.url }).then(function (product) {
      var bag = collectionSingleBag(product);
      return bag || firstLiveSearchProduct(products, index + 1);
    });
  }
  function searchSingleBag(candidate, queryIndex) {
    var queries = [candidate.sku, candidate.title];
    if (queryIndex >= queries.length) return Promise.resolve(null);
    var rootUrl = (HB.routes.root || '/').replace(/\/?$/, '/');
    var url = rootUrl + 'search/suggest.json?q=' + encodeURIComponent(queries[queryIndex]) +
      '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show';
    return fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (payload) {
        var products = payload && payload.resources && payload.resources.results && payload.resources.results.products || [];
        products = products.filter(function (product) {
          var lookup = String(product.title || '') + ' ' + String(product.handle || '');
          return /102g/i.test(lookup) && !/3\s*[x×-]|3-pack/i.test(lookup);
        });
        return firstLiveSearchProduct(products, 0);
      }).catch(function () { return null; })
      .then(function (bag) { return bag || searchSingleBag(candidate, queryIndex + 1); });
  }
  function fetchKnownSingleBags() {
    return Promise.all(singleBagCandidates.map(function (candidate) {
      return firstLiveHandle(candidate.handles, 0).then(function (bag) {
        return bag || searchSingleBag(candidate, 0);
      }).then(function (bag) {
        if (bag) bag.key = candidate.key;
        return bag;
      });
    })).then(function (products) { return products.filter(Boolean); });
  }
  function liveSingleBag(seed, spec) {
    return fetchProduct(seed).then(function (product) {
      /* The Liquid seed already comes from the authoritative cart-singles
         collection and reflects storefront availability at render time. Product
         JSON is a freshness enhancement, not a reason to erase every upsell when
         a password/theme-preview request is challenged or transiently fails. */
      if (!product || !product.variants) {
        return seed && seed.variant && seed.variant.id && seed.variant.available === true && seed.variant.price != null ? seed : null;
      }
      var wantedSkus = [spec.sku, seed.variant && seed.variant.sku].filter(Boolean).map(function (sku) { return String(sku).toLowerCase(); });
      var wantedId = String(seed.variant && seed.variant.id || '');
      var variant = product.variants.filter(function (item) { return wantedSkus.indexOf(String(item.sku || '').toLowerCase()) > -1; })[0];
      if (!variant && wantedId) variant = product.variants.filter(function (item) { return String(item.id) === wantedId; })[0];
      if (!variant && product.variants.length === 1) variant = product.variants[0];
      if (!variant || variant.available !== true || variant.price == null) return null;
      return {
        key: spec.key,
        handle: product.handle || seed.handle,
        url: product.url || seed.url,
        name: seed.name || product.title,
        pc: seed.pc,
        bc: seed.bc,
        pack: variant.featured_image && (variant.featured_image.src || variant.featured_image.url) || product.featured_image || product.images && product.images[0] || seed.pack || null,
        variant: {
          id: variant.id,
          title: variant.title,
          sku: variant.sku || spec.sku,
          price: variant.price,
          compare: variant.compare_at_price,
          available: true
        }
      };
    });
  }

  function syncSingleBags() {
    if (!upsellEnabled) { upsellLoading = false; return Promise.resolve([]); }
    var data = HB.data();
    /* The cart drawer owns its catalogue feed. Rendering it beside the drawer
       avoids relying on another section's cached #hb-data and makes the five
       collection products visible immediately, before any Ajax refresh. */
    var cartSeeds = cfg.upsellCollection === 'heybear-102g-cart-singles' ? (cfg.upsells || []).slice() : [];
    var sharedSeeds = data.upsellCollection === 'heybear-102g-cart-singles' ? (data.upsells || []).slice() : [];
    var seeds = cartSeeds.length ? cartSeeds : sharedSeeds;
    if (seeds.length) {
      data.upsells = seeds;
      data.upsellCollection = 'heybear-102g-cart-singles';
      upsellLoading = false;
      if (HB.cart.state) render(HB.cart.state);
    }
    return fetchSingleBagCollection().then(function (collectionProducts) {
      if (collectionProducts && collectionProducts.length) return collectionProducts;
      return fetchKnownSingleBags().then(function (knownProducts) {
        if (knownProducts.length) return knownProducts;
        return Promise.all(seeds.map(function (seed) {
          return liveSingleBag(seed, { key: seed.key, sku: seed.variant && seed.variant.sku });
        })).then(function (products) { return products.filter(Boolean); });
      });
    }).then(function (products) {
      if (!alive) return [];
      var found = products && products.length ? products : seeds;
      HB.data().upsells = found;
      HB.data().upsellCollection = 'heybear-102g-cart-singles';
      upsellLoading = false;
      if (HB.cart.state) render(HB.cart.state);
      return found;
    });
  }

  function openCart() {
    lastFocus = document.activeElement; drawer.classList.add('open'); scrim.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false'); HB.lock(true);
    setTimeout(function () { $('#drClose').focus({ preventScroll: true }); }, 60);
  }
  function closeCart() {
    drawer.classList.remove('open'); scrim.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true'); HB.lock(false);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  on(document, 'hb:cart:open', openCart);
  on($('#drClose'), 'click', closeCart);
  on(scrim, 'click', closeCart);
  on($('#drShop'), 'click', closeCart);
  on(window, 'keydown', function (e) {
    if (!drawer.classList.contains('open')) return;
    if (e.key === 'Escape') closeCart();
    if (e.key === 'Tab') {
      var f = [].slice.call(drawer.querySelectorAll('button,a[href],input')).filter(function (x) { return x.offsetParent; }); if (!f.length) return;
      var a = f[0], z = f[f.length - 1];
      if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
      else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
    }
  });

  /* ---- describe a Shopify line item in the approved design's words ---- */
  function lineImage(line) {
    if (line && line.featured_image && line.featured_image.url) return line.featured_image.url;
    if (line && typeof line.image === 'string') return line.image;
    if (line && line.image && (line.image.src || line.image.url)) return line.image.src || line.image.url;
    return '';
  }
  function info(line) {
    var D = HB.data(), mix = D.mix, f = D.flavours.filter(function (x) { return x.handle === line.handle; })[0];
    var singleBag = (D.upsells || []).filter(function (x) { return x.handle === line.handle; })[0];
    var vt = line.variant_title || '', bags = HB.bags({ title: vt }), plan = line.selling_plan_allocation && line.selling_plan_allocation.selling_plan;
    var upsell = line.properties && line.properties._hb_upsell;
    var o;
    if (mix && line.handle === mix.handle) {
      var big = /big/i.test(vt);
      o = { kind: big ? 'big' : 'cub', name: (big ? 'Big Bear' : 'Cub') + ' mixed pack', desc: big ? '12 × 102g · 4 flavours + free gift' : '4 × 102g · one of each flavour', tb: HB.mixBg, tc: big ? '#9A5A2C' : '#6A8A34', n: big ? '×12' : '×4' };
    } else if (singleBag) {
      o = { kind: 'single-bag', key: singleBag.key, name: singleBag.name, desc: '102g · cart-only add-on', tb: singleBag.pc, tc: singleBag.bc, n: '×1' };
    } else if (f) {
      o = { kind: 'single', key: f.key, name: f.name + ' 3-Pack', desc: '3 × 102g · single flavour', tb: f.pc, tc: f.bc, n: '×3' };
    } else {
      o = { kind: 'other', name: line.product_title + (vt ? ' ' + vt : ''), desc: '', tb: '#F5CFA0', tc: '#9A5A2C', n: '×' + line.quantity };
    }
    if (plan) { o.name += ' · Subscribe'; o.desc = o.desc.split(' · ')[0] + ' · ' + plan.name; }
    o.upsell = !!upsell;
    o.image = lineImage(line);
    o.alt = line.product_title || o.name;
    return o;
  }
  function isUpsellLine(line) {
    return !!(line && line.properties && line.properties._hb_upsell === '102g single bag');
  }
  function hasThreePack(cart) {
    var handles = (HB.data().flavours || []).map(function (product) { return product.handle; });
    return (cart && cart.items || []).some(function (line) {
      return !isUpsellLine(line) && handles.indexOf(line.handle) > -1;
    });
  }
  function upsellQuantity(cart) {
    return (cart && cart.items || []).reduce(function (total, line) {
      return total + (isUpsellLine(line) ? line.quantity : 0);
    }, 0);
  }
  function reconcileUpsells(cart) {
    if (!cart || reconcilingUpsells) return false;
    var lines = (cart.items || []).filter(isUpsellLine);
    if (!lines.length) return false;
    var qualifying = hasThreePack(cart), remaining = qualifying ? MAX_SINGLE_BAG_UPSELLS : 0, updates = {};
    lines.forEach(function (line) {
      var wanted = Math.min(line.quantity, remaining);
      remaining -= wanted;
      if (wanted !== line.quantity) updates[line.key] = wanted;
    });
    if (!Object.keys(updates).length) return false;
    reconcilingUpsells = true;
    HB.cart.update(updates).catch(function () { render(cart); }).then(function () { reconcilingUpsells = false; });
    return true;
  }
  function handleCart(cart) {
    if (!reconcileUpsells(cart)) render(cart);
  }
  var thumb = function (it) {
    var media = it.image
      ? '<img src="' + esc(it.image) + '" alt="' + esc(it.alt || it.name || '') + '">'
      : '<svg viewBox="0 0 100 124" aria-hidden="true"><use href="#bear"/></svg>';
    return '<span class="dr-thumb' + (it.image ? ' dr-thumb--product' : '') + '" style="--tb:' + it.tb + ';--tc:' + it.tc + '">' + media + '<i>' + it.n + '</i></span>';
  };

  var fresh = null, prevKeys = null;
  function render(cart) {
    if (!cart) return;
    var keysNow = (cart.items || []).map(function (l) { return l.key; });
    var D = HB.data(), items = cart.items || [], sub = cart.total_price || 0, count = cart.item_count || 0;
    var mix = D.mix;
    var eligibleForSingles = hasThreePack(cart), singleBagCount = upsellQuantity(cart);
    var hasBig = items.some(function (l) { return mix && l.handle === mix.handle && /big/i.test(l.variant_title || ''); });
    $('#drCount').textContent = count;
    $('#drItems').innerHTML = items.map(function (l) {
      var it = info(l);
      return '<li class="dr-item" data-key="' + esc(l.key) + '" ' + ((l.key === fresh || (prevKeys && prevKeys.indexOf(l.key) < 0)) ? '' : 'style="animation:none"') + '>' + thumb(it) +
        '<div class="dr-info"><b>' + esc(it.name) + '</b><small>' + esc(it.desc) + '</small>' +
        '<div class="qty"><button type="button" data-q="-1" aria-label="Decrease quantity of ' + esc(it.name) + '">−</button><output aria-live="polite">' + l.quantity + '</output><button type="button" data-q="1" aria-label="Increase quantity of ' + esc(it.name) + '"' + (it.upsell && singleBagCount >= MAX_SINGLE_BAG_UPSELLS ? ' disabled title="Maximum of 4 single bags"' : '') + '>+</button></div></div>' +
        '<div class="dr-right"><b>' + HB.money(l.final_line_price) + '</b><button type="button" class="dr-rm" data-rm>' + esc(t.remove || 'Remove') + '</button></div></li>';
    }).join('');
    fresh = null; prevKeys = keysNow;
    $('#drEmpty').hidden = items.length > 0; $('#drFoot').hidden = items.length === 0;
    var freeAt = cfg.freeAt, unlocked = hasBig || sub >= freeAt, left = Math.max(0, freeAt - sub), pct = unlocked ? 100 : Math.min(100, sub / freeAt * 100);
    $('#drShipText').innerHTML = !items.length ? t.shipEmpty : unlocked ? t.shipDone : String(t.shipLeft || '').replace('[amount]', HB.money(left));
    $('#drFill').style.width = pct + '%'; $('#drCar').style.left = pct + '%';
    $('#drSub').textContent = HB.money(sub); $('#drTotal').textContent = HB.money(sub);
    $('#drShipCost').innerHTML = unlocked ? t.shipFree : t.shipCalc;

    /* upsell 1: swap a Cub for the Big Bear */
    var u = '', cubLine = mix && items.filter(function (l) { return l.handle === mix.handle && /cub/i.test(l.variant_title || '') && !l.selling_plan_allocation; })[0];
    var bigV = mix && HB.variantMatch(mix, /big/i);
    if (cfg.swapOn && cubLine && !hasBig && bigV && bigV.id && bigV.available === true && bigV.price != null) {
      var cubV = HB.variantMatch(mix, /cub/i);
      var swapText = cubV
        ? HB.money(bigV.price / 12) + '/bag vs ' + HB.money(cubV.price / 4) + '/bag, plus free shipping and a free gift'
        : t.swapText;
      u = '<div class="k">' + t.swapKicker + '</div><div class="u">' + thumb({ image: bigV.image || mix.pack || mix.photos && mix.photos[0], alt: t.swapTitle || 'Big Bear mixed pack', tb: HB.mixBg, tc: '#9A5A2C', n: '×12' }) +
        '<div><b>' + t.swapTitle + '</b><small>' + swapText + '</small></div><button type="button" data-up="swap">' + String(t.swapBtn || '').replace('[price]', HB.money(bigV.price)) + '</button></div>';
    }
    $('#drUpsell').innerHTML = items.length ? u : '';

    /* upsell 2: add one 102g bag of any flavour */
    var fav = upsellLoading && eligibleForSingles ? '<div class="fv-load" role="status"><span aria-hidden="true"></span>Loading single bags…</div>' : '';
    if (upsellEnabled && eligibleForSingles && !upsellLoading) {
      var list = D.upsellCollection === 'heybear-102g-cart-singles'
        ? (D.upsells || []).map(function (p) { return { p: p, v: p.variant }; }).filter(function (x) { return x.v && x.v.id && x.v.available === true; })
        : [];
      if (list.length) {
        var prices = list.map(function (x) { return x.v.price; });
        var price = Math.min.apply(Math, prices), samePrice = prices.every(function (value) { return value === price; });
        var n = Math.ceil(left / price);
        fav = '<div class="fv-h"><div><b>' + t.favTitle + '</b><small>' + t.favText + '</small></div><div class="fv-p">' + (samePrice ? '' : '<small>From</small>') + '<b>' + HB.money(price) + '</b></div></div>' +
          (!unlocked && samePrice && n <= 3 ? '<p class="fv-hint">' + String(t.favHint || '').replace('[n]', n).replace('[s]', n > 1 ? 's' : '') + '</p>' : '') +
          '<ul class="fv-list">' + list.map(function (x) {
            var line = items.filter(function (l) { return l.variant_id === x.v.id && l.properties && l.properties._hb_upsell; })[0];
            return '<li data-v="' + (x.v.id || '') + '"' + (line ? ' data-key="' + esc(line.key) + '" data-qty="' + line.quantity + '"' : '') + '><img src="' + esc(x.p.pack || '') + '" alt="' + esc(x.p.name) + '"><span>' + esc(x.p.name) + '<small>102g · ' + HB.money(x.v.price) + '</small></span>' +
              (line ? '<div class="qty fv-q"><button type="button" data-fq="-1" aria-label="Remove one ' + esc(x.p.name) + '">−</button><output>' + line.quantity + '</output><button type="button" data-fq="1" aria-label="Add another ' + esc(x.p.name) + '"' + (singleBagCount >= MAX_SINGLE_BAG_UPSELLS ? ' disabled title="Maximum of 4 single bags"' : '') + '>+</button></div>'
                : '<button type="button" class="fv-add" data-fq="1"' + (singleBagCount >= MAX_SINGLE_BAG_UPSELLS ? ' disabled title="Maximum of 4 single bags"' : '') + '>' + esc(t.favAdd || '+ Add') + '</button>') + '</li>';
          }).join('') + '</ul>';
      }
    }
    $('#drFav').innerHTML = fav;
    $('#drNote').textContent = t.note || '';
  }
  on(document, 'hb:cart:updated', function (e) { handleCart(e.detail); });
  on(document, 'hb:catalog:updated', function () { if (HB.cart.state) render(HB.cart.state); });
  if (HB.cart.state) handleCart(HB.cart.state);
  syncSingleBags();

  on($('#drItems'), 'click', function (e) {
    var li = e.target.closest('.dr-item'); if (!li) return;
    var key = li.getAttribute('data-key'), line = (HB.cart.state.items || []).filter(function (l) { return l.key === key; })[0]; if (!line) return;
    var q = e.target.closest('[data-q]');
    if (q) {
      var delta = +q.getAttribute('data-q');
      if (delta > 0 && isUpsellLine(line) && upsellQuantity(HB.cart.state) >= MAX_SINGLE_BAG_UPSELLS) {
        HB.toast('You can add up to 4 single bags.');
        return;
      }
      HB.cart.change(key, Math.max(0, line.quantity + delta));
    }
    if (e.target.closest('[data-rm]')) HB.cart.change(key, 0);
  });
  on($('#drUpsell'), 'click', function (e) {
    var b = e.target.closest('[data-up]'); if (!b) return;
    var D = HB.data(), mix = D.mix, bigV = HB.variantMatch(mix, /big/i);
    var cubLine = (HB.cart.state.items || []).filter(function (l) { return mix && l.handle === mix.handle && /cub/i.test(l.variant_title || ''); })[0];
    if (!bigV || !bigV.id || bigV.available !== true || bigV.price == null || !cubLine) return;
    HB.cart.change(cubLine.key, 0).then(function () { return HB.cart.add([{ id: bigV.id, quantity: 1 }]); });
  });
  on($('#drFav'), 'click', function (e) {
    var b = e.target.closest('[data-fq]'); if (!b) return;
    var li = b.closest('li'), d = +b.getAttribute('data-fq'), key = li.getAttribute('data-key');
    if (d > 0 && !hasThreePack(HB.cart.state)) {
      HB.toast('Add a 3-pack to unlock single bags.');
      return;
    }
    if (d > 0 && upsellQuantity(HB.cart.state) >= MAX_SINGLE_BAG_UPSELLS) {
      HB.toast('You can add up to 4 single bags.');
      return;
    }
    if (d > 0 && !key) {
      var vid = +li.getAttribute('data-v');
      HB.cart.add([{ id: vid, quantity: 1, properties: { _hb_upsell: '102g single bag' } }]).then(function (c) {
        var l = (c.items || []).filter(function (x) { return x.variant_id === vid && x.properties && x.properties._hb_upsell; })[0];
        if (l) { fresh = l.key; render(c); }
      });
    } else if (key) {
      HB.cart.change(key, Math.max(0, (+li.getAttribute('data-qty')) + d));
    }
  });
  on($('#drCheckout'), 'click', function () { location.href = (HB.routes.root || '/').replace(/\/?$/, '/') + 'checkout'; });

  return function () { alive = false; off.forEach(function (f) { f(); }); };
});
